import { render, staticRenderFns } from "./chart-legend.vue?vue&type=template&id=c577db38&"
import script from "./chart-legend.vue?vue&type=script&lang=js&"
export * from "./chart-legend.vue?vue&type=script&lang=js&"
import style0 from "./chart-legend.vue?vue&type=style&index=0&id=c577db38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports